import React, { useEffect, useState } from "react";
import avatar from "./asserts/def-ava.png";
import { useNavigate, useParams } from "react-router-dom";

const SkydiverPublicProfile = () => {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const [datas, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [mode, setMode] = useState("skydive"); // skydive | tunnel
  const [locationMode, setLocationMode] = useState("dropzone"); // dropzone | tunnel

  const switchWrapper = {
    display: "flex",
    background: "#1F2937",
    borderRadius: "999px",
    padding: "3px",
    width: "fit-content",
  };

  const switchBtn = (active) => ({
    padding: "4px 10px",
    borderRadius: "999px",
    border: "none",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600",
    background: active ? "#374151" : "transparent",
    color: active ? "#fff" : "#9CA3AF",
    transition: "all 0.2s ease",
  });
  const switchTextStyle = {
    cursor: "pointer",
    transition: "opacity 0.2s ease",
  };

  const activeTextStyle = {
    color: "#F3F4F6",
    fontWeight: "600",
  };

  const inactiveTextStyle = {
    color: "#6B7280",
    fontWeight: "500",
  };


  const formatMinutes = (totalMinutes) => {
    if (!totalMinutes) return "0 мин";

    const totalSeconds = totalMinutes * 60;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours} ч ${minutes} мин ${seconds} сек`;
  };
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetch(`/api/personaldata/public/${publicId}`)
      .then(res => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [publicId]);

  if (loading) return <div style={pageStyle}><p>Загрузка профиля...</p></div>;
  if (!datas)
    return (
      <div style={pageStyle}>
        <p>Профиль не найден</p>
        <button style={portalBtnStyle} onClick={() => navigate("/")}>
          Перейти на портал
        </button>
      </div>
    );

  return (
    <div style={pageStyle}>
      <div style={{ width: "100%", maxWidth: "1100px" }}>

        {/* HEADER */}
        <div style={{
          ...headerStyle,
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "flex-start",
          textAlign: isMobile ? "center" : "left"
        }}>
          <img
            src={datas.avatarPath || avatar}
            alt="Аватар"
            style={{
              width: "160px",
              height: "160px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #10B981",
            }}
          />
          <div style={{ flex: 1 }}>
            <h2 style={{ ...nameStyle, fontSize: isMobile ? "22px" : "30px" }}>
              <strong>{datas.fullname}</strong>
            </h2>
            <table style={tableStyle}>
              <tbody>
                <tr>
                  <td>Общее количество прыжков:</td>
                  <td><strong>{datas.jumpCount}</strong></td>
                </tr>
                <tr>
                  <td>Текущая система:</td>
                  <td><strong>{datas.currentCanopy}</strong></td>
                </tr>
                <tr>
                  <td>Домашняя дропзона:</td>
                  <td><strong>{datas.dropzone}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Content blocks grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: "30px",
          }}
        >
          {/* ===== СТАТИСТИКА ===== */}
          <div style={sectionStyle}>
            <h3 style={{ ...sectionTitleStyle, display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>

              <span
                onClick={() => setMode("skydive")}
                style={{
                  ...switchTextStyle,
                  ...(mode === "skydive" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Свободное падение
              </span>

              <span style={{ color: "#6B7280" }}>/</span>

              <span
                onClick={() => setMode("tunnel")}
                style={{
                  ...switchTextStyle,
                  ...(mode === "tunnel" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Аэротруба
              </span>

            </h3>

            <table style={tableStyle}>
              <tbody>

                {mode === "skydive" ? (
                  <>
                    <tr>
                      <td>Общее время:</td>
                      <td><strong>{datas.freefallTime}</strong></td>
                    </tr>
                    <tr>
                      <td>В этом году:</td>
                      <td><strong>{datas.freefallTimeAtYear}</strong></td>
                    </tr>
                    <tr>
                      <td>Самое высокое отделение:</td>
                      <td><strong>{datas.maxHeight} м</strong></td>
                    </tr>
                    <tr>
                      <td>Самое низкое раскрытие:</td>
                      <td><strong>{datas.minDeploy} м</strong></td>
                    </tr>
                    <tr>
                      <td>Макс. скорость:</td>
                      <td><strong>{datas.maxSpeed} км/ч</strong></td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr>
                      <td>Общее время налета в трубе:</td>
                      <td><strong>{formatMinutes(datas.tunnelAllTime) || 0}</strong></td>
                    </tr>
                    <tr>
                      <td>Время налета в этом году:</td>
                      <td><strong>{formatMinutes(datas.tunnelYearTime) || 0}</strong></td>
                    </tr>
                  </>
                )}

              </tbody>
            </table>
          </div>

          {/* ===== ТИПЫ ПРЫЖКОВ ===== */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Типы прыжков</h3>
            {loading ? (
              <p>Загрузка...</p>
            ) : datas.jumpTypes && datas.jumpTypes.length > 0 ? (
              <table style={tableStyle}>
                <tbody>
                  {datas.jumpTypes.map((type, index) => (
                    <tr key={index}>
                      <td>{type.jumpType}:</td>
                      <td><strong>{type.count}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ opacity: 0.7 }}>Похоже, данных нет</p>
            )}
          </div>

          {/* ===== ДРОПЗОНЫ / АЭРОТРУБЫ ===== */}
          <div style={sectionStyle}>
            <h3 style={{ ...sectionTitleStyle, display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>

              <span
                onClick={() => setLocationMode("dropzone")}
                style={{
                  ...switchTextStyle,
                  ...(locationMode === "dropzone" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Дропзоны
              </span>

              <span style={{ color: "#6B7280" }}>/</span>

              <span
                onClick={() => setLocationMode("tunnel")}
                style={{
                  ...switchTextStyle,
                  ...(locationMode === "tunnel" ? activeTextStyle : inactiveTextStyle)
                }}
              >
                Аэротрубы
              </span>

            </h3>

            {locationMode === "dropzone" ? (
              datas.dropzones ? (
                <table style={tableStyle}>
                  <tbody>
                    {datas.dropzones.map((dz, index) => (
                      <tr key={index}>
                        <td>{dz.dropzoneName}:</td>
                        <td><strong>{dz.count}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Загрузка...</p>
              )
            ) : (
              datas.tunnels ? (
                <table style={tableStyle}>
                  <tbody>
                    {datas.tunnels.map((tunnel, index) => (
                      <tr key={index}>
                        <td>{tunnel.windtunnelName}:</td>
                        <td><strong>{tunnel.count}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Загрузка...</p>
              )
            )}
          </div>

          {/* ===== ПАРАШЮТНЫЕ СИСТЕМЫ ===== */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Парашютные системы</h3>
            {datas.canopyTypes ? (
              <table style={tableStyle}>
                <tbody>
                  {datas.canopyTypes.map((type, index) => (
                    <tr key={index}>
                      <td>{type.canopyType}:</td>
                      <td><strong>{type.count}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>Загрузка...</p>
            )}
          </div>
        </div>

        {/* PORTAL BUTTON */}
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <button style={{ ...portalBtnStyle, width: isMobile ? "100%" : "auto" }}
            onClick={() => navigate("/")}>
            Перейти на портал
          </button>
        </div>

      </div>
    </div>
  );
};

export default SkydiverPublicProfile;

// Стили
const pageStyle = {
  minHeight: "100vh",
  padding: "40px 20px",
  display: "flex",
  justifyContent: "center",
  color: "#F3F4F6",
};

const headerStyle = {
  display: "flex",
  gap: "30px",
  backgroundColor: "rgba(17, 24, 39, 0.75)",
  padding: "30px",
  borderRadius: "16px",
  marginBottom: "30px",
};

const avatarStyle = {
  width: "160px",
  height: "160px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "3px solid #10B981",
};

const nameStyle = {
  fontSize: "30px",
  marginBottom: "20px",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "30px",
};

const sectionStyle = {
  backgroundColor: "rgba(31, 41, 55, 0.7)",
  padding: "25px 30px",
  borderRadius: "16px",
  backdropFilter: "blur(6px)",
  boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
  minWidth: 0,
};

const sectionTitleStyle = {
  marginBottom: "18px",
  fontSize: "20px",
  borderBottom: "1px solid rgba(255,255,255,0.2)",
  paddingBottom: "8px",
};

const tableStyle = {
  width: "100%",
  borderSpacing: "8px",
};

const portalBtnStyle = {
  padding: "14px 28px",
  borderRadius: "12px",
  border: "none",
  background: "linear-gradient(135deg, #10B981, #059669)",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  cursor: "pointer",
};